(function () {
  'use strict';

  // TASK-3471 — only the DEV token layer (html.ils-tok-3428) renders the -X%
  // discount chip (.ils-price__pct, TASK-3451). Production has neither the chip
  // nor this class, so SHOW_PCT stays false there and behaviour is unchanged.
  var SHOW_PCT = document.documentElement.classList.contains('ils-tok-3428');

  /* TASK-4846 — ONE global money format on EVERY published locale,
     English included: decimal separator ',' and thousands separator '.'
     (€0,00 / €89,90 / €1.234,56). Deliberately not Intl.NumberFormat or
     toLocaleString: this is a storefront business rule, not a locale
     convention, and en-* would render €1,234.56. Same algorithm as
     moneyFromCents() in custom-cart-drawer.js. Presentation only — the
     numeric value and its rounding are untouched. */
  function fmtMoney(cents) {
    /* TASK-5856 — REPORT-5848 D4. These cents are a PRESENTMENT price (a variant
       price / a saving), so on the six local-currency markets the body below
       printed a kr amount with a euro sign: the card first-painted correctly from
       Liquid `| money` ("57,00 kr") and then rewrote itself to "€57,00" the
       moment a weight pill was tapped — on the collection grid, the homepage
       rails, related products, search and the 404 page. ILSMoney.fromCents()
       prints the format Shopify itself rendered on the same page; it returns null
       when the oracle is absent, disabled or unsure, and then the legacy body
       runs unchanged, so EUR markets keep exactly today's bytes. This is the same
       three-line guard already live in custom-cart-drawer.js:86-89. */
    if (window.ILSMoney && window.ILSMoney.on()) {
      var _p5856 = window.ILSMoney.fromCents(cents);
      if (_p5856 !== null) return _p5856;
    }
    var n = Math.round(Number(cents) || 0);
    var sign = n < 0 ? '-' : '';
    var abs = Math.abs(n);
    var frac = String(abs % 100);
    while (frac.length < 2) frac = '0' + frac;
    /* TASK-5946 — display only: a FULLY zero fraction prints as no fraction. */
    return sign + '€' + String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (frac === '00' ? '' : ',' + frac);
  }

  // TASK-2569: localized "Save €X" on collection-grid cards, re-rendered on
  // weight/variant switch. Reads the translated `custom.product.save_amount`
  // template from the price host (data-save-tpl, money slot = brace-free
  // __AMOUNT__ sentinel) and substitutes the amount as PLAIN TEXT via
  // textContent, so it can never leak markup (the TASK-2565 bug class). Falls
  // back to English "Save €X" if the host/attr is absent.
  function saveLabel(host, save) {
    var amount = fmtMoney(save);
    var tpl = host && host.getAttribute && host.getAttribute('data-save-tpl');
    if (tpl && /__AMOUNT__|\{\{\s*amount\s*\}\}/.test(tpl)) {
      return tpl.replace(/__AMOUNT__|\{\{\s*amount\s*\}\}/g, amount);
    }
    return 'Save ' + amount;
  }

  function initCard(card) {
    var pills   = card.querySelectorAll('.ils-weight-btn');
    var priceEl = card.querySelector('.ils-price');
    var inputEl = card.querySelector('.ils-variant-input');

    if (!pills.length || !priceEl) return;

    var row1 = priceEl.querySelector('.ils-price__row1');
    var row2 = priceEl.querySelector('.ils-price__row2');
    if (!row1 || !row2) return;

    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        if (pill.dataset.soldout) return;

        pills.forEach(function(p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        if (inputEl) inputEl.value = pill.dataset.variantId;

        var price   = parseInt(pill.dataset.price, 10);
        var compare = parseInt(pill.dataset.comparePrice, 10);

        if (compare && compare > price) {
          var save = compare - price;
          priceEl.classList.add('is-sale');
          row1.innerHTML =
            '<span class="ils-price__new">' + fmtMoney(price) + '</span>' +
            '<span class="ils-price__old">' + fmtMoney(compare) + '</span>';
          // TASK-3471 — re-create the -X% badge (TASK-3451) that the old
          // row2.innerHTML overwrote on switch. Same math as the Liquid /
          // PDP save_pct: round((compare - price) * 100 / compare).
          var ilsPctHtml = '';
          if (SHOW_PCT) {
            var pct = Math.round((compare - price) * 100 / compare);
            ilsPctHtml = '<span class="ils-price__pct" aria-label="-' + pct + '%">-' + pct + '%</span>';
          }
          row2.innerHTML = ilsPctHtml + '<span class="ils-price__save"></span>';
          row2.querySelector('.ils-price__save').textContent = saveLabel(priceEl, save);
        } else {
          priceEl.classList.remove('is-sale');
          row1.innerHTML = '<span class="ils-price__plain">' + fmtMoney(price) + '</span>';
          row2.innerHTML = '';
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.card-wrapper').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
